module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-everest-iStock-1199648281.c1d78f31.jpg";